<template>
  <b-form-select
    v-model="content"
    :options="options"
    size="md"
    @input="handleInput"
  ></b-form-select>
</template>

<script>
import objectsQuery from '@/api/objects/availableObjects.gql';

export default {
  name: 'ObjectSelect',
  props: ['value'],
  data() {
    return {
      content: this.value,
    };
  },
  computed: {
    options() {
      let objects = this.availableObjects || [];

      return objects.map((obj) => {
        return {
          text: obj.name,
          value: obj.id,
        };
      });
    },
  },
  methods: {
    handleInput() {
      this.$emit('input', this.content);
    },
  },
  apollo: {
    availableObjects: {
      query() {
        return objectsQuery;
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.availableObjects && queryData.availableObjects.length) {
          return queryData.availableObjects;
        } else {
          return [];
        }
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
};
</script>

<style></style>
